import React from 'react';
import { useT } from '../../i18n';
import DateTimeDisplay from './DateTimeDisplay';
import { useCountdown } from '../../context/useCountdown';

const ShowCounter = ({ days, hours, minutes, seconds, isDanger }) => {
  const t = useT();
  return (
    <div className="show-counter">
      <div className="countdown-link">
        <DateTimeDisplay value={days} type={t('countdown.days')} isDanger={isDanger} />
        <DateTimeDisplay value={hours} type={t('countdown.hours')} isDanger={isDanger} />
        <DateTimeDisplay value={minutes} type={t('countdown.mins')} isDanger={isDanger} />
        <DateTimeDisplay value={seconds} type={t('countdown.secs')} isDanger={isDanger} />
      </div>
    </div>
  );
};

const CountdownTimer = ({ targetDate }) => {
  const t = useT();
  const [days, hours, minutes, seconds] = useCountdown(targetDate);

  // No target yet (still fetching from the contract), so show placeholders instead
  // of the NaN values the old version rendered.
  if ([days, hours, minutes, seconds].some((value) => Number.isNaN(value))) {
    return (
      <ShowCounter days="-" hours="-" minutes="-" seconds="-" isDanger={false} />
    );
  }

  if (days + hours + minutes + seconds <= 0) {
    return (
      <p className="lb-gradient-text font-display text-xl font-extrabold uppercase">
        {t('countdown.anyMoment')}
      </p>
    );
  }

  // Under an hour to go, so highlight it.
  const isDanger = days === 0 && hours === 0;

  return (
    <ShowCounter
      days={days}
      hours={hours}
      minutes={minutes}
      seconds={seconds}
      isDanger={isDanger}
    />
  );
};

export default CountdownTimer;
